import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class ThemeConstantService {
    
    // Theme Config
    isMenuFolded = false;
    isSideNavDark = true;
    headerColor = 'primary';
    private colorConfig: any = {
        colors: {
            magenta: '#eb2f96',
            magentaLight: 'rgba(235, 47, 150, 0.05)',
            red: '#de4436',
            redLight: 'rgba(222, 68, 54, 0.05)',
            volcano: '#fa541c',
            volcanoLight: 'rgba(250, 84, 28, 0.05)',
            orange: '#fa8c16',
            orangeLight: 'rgba(250, 140, 22, 0.1)',
            gold: '#ffc107',
            goldLight: 'rgba(255, 193, 7, 0.1)',
            lime: '#a0d911',
            limeLight: 'rgba(160, 217, 17, 0.1)',
            green: '#00945E',
            greenLight: 'rgba(82, 196, 26, 0.1)',
            cyan: '#05c9a7',
            cyanLight: 'rgba(0, 201, 167, 0.1)',
            blue: '#234e9e',
            blueLight: 'rgba(0, 71, 187, 1)',
            geekBlue: '#2f54eb',
            geekBlueLight: 'rgba(47, 84, 235, 0.1)',
            purple: '#886cff',
            purpleLight: 'rgba(136, 108, 255, 0.1)',

            border: '#edf2f9',
            white: '#ffffff',
            dark: '#2a2a2a',
            transparent: 'rgba(255, 255, 255, 0)',

            // Brand colors
            brandPrimary: '#234e9e',
            brandSecondary: '#FFD100',
            
            // Gray support colors
            gray: '#404040',
            grayLight: '#A4A4A4',
            grayLighter: '#CCCCCC',
            grayLightest: '#E7E8E9',

          
            // Charts colors
            chart: {
                color1: '#234e9e',
                color2: '#ffd000',
                color3: '#00945e',
                color4: '#e62d39',
                color5: '#FF8F1C',
                color6: '#3AB700',
                color7: '#73C2FF',
                color8: '#D151FF',
                color9: '#3B8FFF',
                color10: '#ff402b',
            }
            
        }
    };

    private isMenuFoldedActived = new BehaviorSubject<boolean>(this.isMenuFolded);
    isMenuFoldedChanges: Observable<boolean> = this.isMenuFoldedActived.asObservable();

    private isSideNavDarkActived = new BehaviorSubject<boolean>(this.isSideNavDark);
    isSideNavDarkChanges: Observable<boolean> = this.isSideNavDarkActived.asObservable();

    private isExpandActived = new BehaviorSubject<boolean>(false);
    isExpandChanges: Observable<boolean> = this.isExpandActived.asObservable();

    private currentHeaderColor = new BehaviorSubject(this.headerColor);
    selectedHeaderColor = this.currentHeaderColor.asObservable();

    get() {
        return this.colorConfig;
    }

    toggleFold(isFolded: boolean) {
        this.isMenuFoldedActived.next(isFolded);
    }

    toogleSideNavDark(isDark:boolean) {
        this.isSideNavDarkActived.next(isDark);
    }

    toggleExpand(isExpand:boolean) {
        this.isExpandActived.next(isExpand);
    }

    changeHeaderColor(color: string) {
        this.currentHeaderColor.next(color);
    }
}